import { AstNodeCategory, AstNodeType } from './node';
export class Identifier {
    constructor(token, value) {
        this.token = token;
        this.value = value;
        this.nodeType = AstNodeType.Identifier;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Value() {
        return this.value;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        return this.value;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWRlbnRpZmllci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvYXN0L0lkZW50aWZpZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLGVBQWUsRUFBRSxXQUFXLEVBQWMsTUFBTSxRQUFRLENBQUM7QUFFbEUsTUFBTSxPQUFPLFVBQVU7SUFDbkIsWUFBb0IsS0FBWSxFQUFVLEtBQWE7UUFBbkMsVUFBSyxHQUFMLEtBQUssQ0FBTztRQUFVLFVBQUssR0FBTCxLQUFLLENBQVE7UUFDdkQsYUFBUSxHQUFnQixXQUFXLENBQUMsVUFBVSxDQUFDO1FBQy9DLGlCQUFZLEdBQW9CLGVBQWUsQ0FBQyxVQUFVLENBQUM7SUFGRCxDQUFDO0lBSTNELElBQUksS0FBSztRQUNMLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQztJQUN0QixDQUFDO0lBRUQsWUFBWTtRQUNSLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUM7SUFDOUIsQ0FBQztJQUVELFFBQVE7UUFDSixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUM7SUFDdEIsQ0FBQztDQUNKIn0=